import { createSlotRecipe } from './runtime.js';

const chatChainOfThoughtConfig = {"name":"chatChainOfThought","slots":["root","trigger","content","preview","steps","step","stepLabel","stepBody"]}

export const chatChainOfThought = /* @__PURE__ */ createSlotRecipe(chatChainOfThoughtConfig)